/**
 * Insta Tools pricing configuration.
 * Shape mirrors marketplace pricing config for future checkout integration.
 */

export const INSTA_TOOL_FEATURES_INITIAL_VISIBLE = 5;

/**
 * Free tier — default plan for every influencer. Not purchasable; covers the
 * features that are NOT part of the paid Premium feature set (media dashboards only).
 * Keep the feature keys in sync with modules/influencer-subscription/config/influencerFeatureAccess.config.js (`PLAN_FEATURES.free`).
 */
export const FREE_PLAN = {
  id: "insta_tools_free",
  planType: "free",
  billingCycle: null,
  productType: "insta_tools",
  name: "Insta Tools Free",
  theme: "light",
  badge: "Default plan",
  description:
    "Everything you get automatically when you join Infuber — no payment required.",
  price: 0,
  currencySymbol: "₹",
  features: [
    { label: "YouTube Media Dashboard", enabled: true },
    { label: "Instagram Media Dashboard", enabled: true },
  ],
  cta: "Included with signup",
  disabled: true,
};

/**
 * Paid tier — unlocks DM automation, affiliate links, and link management on top
 * of everything in the Free plan. Keep in sync with `PLAN_FEATURES.premium`.
 */
export const INSTA_TOOL_PLAN = {
  id: "insta_tools_premium",
  planType: "premium",
  billingCycle: "monthly",
  productType: "insta_tools",
  name: "Insta Tools Premium",
  theme: "dark",
  badge: "All-in-one",
  description:
    "Unlock Instagram growth tools — automation, links, and marketplace access in one plan.",
  price: 99,
  currencySymbol: "₹",
  features: [
    { label: "YouTube Media Dashboard", enabled: true },
    { label: "Instagram Media Dashboard", enabled: true },
    { label: "DM Automation", enabled: true },
    { label: "Affiliate Link Generation", enabled: true },
    { label: "Link Management", enabled: true },
    { label: "Marketplace Registration", enabled: true },
    { label: "Campaign Management", enabled: true },
    { label: "Analytics Dashboard", enabled: true },
    { label: "Performance Reports", enabled: true },
    { label: "Priority Email Support", enabled: true },
  ],
  cta: "Upgrade to Premium",
  disabled: false,
};

/** All Insta Tools plans in display order (lowest → highest). */
export const INSTA_TOOL_PLANS = [FREE_PLAN, INSTA_TOOL_PLAN];

/** Plan tier for comparing which cards to show (hide tiers below current plan). */
export const INSTA_TOOL_PLAN_TIER = {
  free: 0,
  premium: 1,
};

export function getVisibleInstaToolPlans(currentPlanType = "free") {
  const currentTier = INSTA_TOOL_PLAN_TIER[currentPlanType] ?? 0;
  return INSTA_TOOL_PLANS.filter(
    (plan) => (INSTA_TOOL_PLAN_TIER[plan.planType] ?? 0) >= currentTier
  );
}
